import { render, staticRenderFns } from "./itPrivacy.vue?vue&type=template&id=13513041&scoped=true&"
import script from "./itPrivacy.vue?vue&type=script&lang=js&"
export * from "./itPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./itPrivacy.vue?vue&type=style&index=0&id=13513041&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13513041",
  null
  
)

export default component.exports